module.exports = __webpack_public_path__ + "img/gulerodsmuffins.ad8f13db.jpg";